import * as Sentry from "@sentry/browser";
import 'livewire-sortable';
import './echo';
import L from 'leaflet';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true
});

window.LeafletReady = (async () => {
    window.L = L;

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
        iconRetinaUrl,
        iconUrl,
        shadowUrl
    });

    if (!('type' in globalThis)) {
        globalThis.type = null;
    }

    await import('leaflet-draw');
    await import('leaflet.markercluster');

    return L;
})();

import('./leaflet-maps');

if ('serviceWorker' in navigator && window.location.pathname.startsWith('/admin')) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/admin/sw.js', { scope: '/admin/' }).catch((error) => {
            console.error('Admin service worker registration failed.', error);
            Sentry.captureException(error, {
                tags: { area: 'admin-pwa' },
            });
        });
    });
}
